import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Header with full width background */}
      <header className="bg-white dark:bg-gray-800 shadow-md sticky top-0 z-50">
        <div className="max-w-[768px] md:max-w-[960px] mx-auto px-4">
          <Header />
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-[768px] md:max-w-[960px] mx-auto px-4">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;